/* src/app/features/prestacao-informacoes/atualizacao-informacoes-risco/atualizacao-info-risco-detalhe.component.scss */
.moeda {
  text-align: right;
}
/*# sourceMappingURL=atualizacao-info-risco-detalhe.component.css.map */
